<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <!-- <a-select v-model="queryParams.itemCode" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select> -->
              <global-select
                :assembleLabel="false"
                :value.sync="queryParams.itemCode"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="下单类别">
              <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.orderType" >
                <a-select-option v-for="(item) in orderTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="安全库存类别">
              <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.scpSinvClassify" >
                <a-select-option v-for="(item) in classifyOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="项目组">
                <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.projectTeam" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="软货标签">
                <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.softGoodLabel" >
                  <a-select-option v-for="(item) in softGoodLabels" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="是否一件代发">
                <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.isRetailFlag" >
                  <a-select-option v-for="(item) in isRetailFlags" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="是否快递">
                <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.isExpressFlag" >
                  <a-select-option v-for="(item) in isExpressFlags" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <!-- <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']">一键刷新</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SECURITY_TYPE_QUERY_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="conversionRate" slot-scope="{ record }">
            <a-popover>
              <template slot="content">
                <p>即换算比例，1*折换*来源单位=1*基本单位</p>
              </template>
              <span v-if="!isEdit || currentId !== record.id">{{ record.conversionRate }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record.conversionRate" :min="0" size="small" @blur="blur(record)" />
            </a-popover>
          </template>
          <template slot="conversionRateInverse" slot-scope="{ record }">
            <a-popover>
              <template slot="content">
                <p>即换算比例倒数，1*倒数*来源单位=1*基本单位</p>
              </template>
              <span>{{ record.conversionRateInverse }}</span>
            </a-popover>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
          </template>
          <template slot="isRetailFlag" slot-scope="{ record }">
            <span>{{ record.isRetailFlag==='Y'?'是':'否' }}</span>
          </template>
          <!-- 操作 -->
          <!-- <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:mdmUomConversions:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span> -->
        </ls-api-table>

      </div>
    </template>
  </ls-table-layout>
</template>
  <script>
    import { apiItemProductAttributeList } from '@/api/scp/general-parameter-settings/security-type-definition.js'
  import { generateLsTableResData } from '@/utils/util.js';
  export default {
    // eslint-disable-next-line
    name: 'Security-type-query',
    components: {
    },
    data () {
      return {
        classifyOptions: [],
        orderTypeOptions: [],
        tableDataList: [],
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiItemProductAttributeList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          uomClassList: undefined,
          unitOfMeasureList: undefined,
          baseUomList: undefined,
          projectTeam: undefined, // 项目组
          foldNumber: undefined, // 系列主型号
          softGoodLabel: undefined, // 软货标签
          isRetailFlag: undefined, // 是否一件代发
          isExpressFlag: undefined, // 是否快递
          status: undefined
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 是否一件代发
        isRetailFlags: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 是否快递
        isExpressFlags: [
          {
            dictLabel: "快递",
            dictValue: "快递"
          },
          {
            dictLabel: "非快递",
            dictValue: "非快递"
          }
        ],
        // 表格字段
        columns: [
          {
            title: '物料编码',
            dataIndex: 'itemCode',
            stickyFixed: 'left',
            align: 'center',
            width: 180
          },
          {
            title: '规格描述',
            dataIndex: 'specification',
            stickyFixed: 'left',
            ellipsis: true,
            align: 'left',
            width: 220

          },
          {
            title: '下单类别',
            dataIndex: 'orderType',
            width: 120,
            align: 'center'
          },
          {
            title: '项目组',
            dataIndex: 'projectTeam',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '商品类别',
            dataIndex: 'productCategory',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '销售类目',
            dataIndex: 'salesCategory',
            width: 120,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '软货标签',
            dataIndex: 'softGoodLabel',
            ellipsis: true,
            width: 180,
            align: 'center'
          },
          {
            title: '最早上架日期',
            width: 150,
            dataIndex: 'earliestShelfTime',
            scopedSlots: { customRender: 'createTime' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '是否快递',
            dataIndex: 'isExpressFlag',
            width: 150,
            align: 'center'
          },
          {
            title: '是否一件代发',
            dataIndex: 'isRetailFlag',
            scopedSlots: { customRender: 'isRetailFlag' },
            width: 150,
            align: 'center'
          },
          {
            title: '安全库存类别',
            dataIndex: 'scpSinvClassify',
            width: 150,
            align: 'center'
          }
        ],
        uomClassOptions: [], // 来源分类
        projectTeams: [], // 项目组
        softGoodLabels: [], // 软货标签
        unitOfMeasureList: [], // 来源单位
        unitOfMeasureListNew: [] // 基本单位
      }
    },
    created () {
        const lookupQueryParams = {
            lookupType: 'SCP_ORDER_CATEGORY',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryParams).then().then(response => {
        this.orderTypeOptions = response.rows
        })
        const lookupQueryClassifyParams = {
            lookupType: 'SCP_SINV_CLASSIFY',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryClassifyParams).then().then(response => {
        this.classifyOptions = response.rows
        })
        const lookupQuerySoftGoodLabelParams = {
            lookupType: 'SCP_SOFT_GOOD_LABEL',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQuerySoftGoodLabelParams).then().then(response => {
        this.softGoodLabels = response.rows
        })
        const lookupQueryProjectTeamParams = {
            lookupType: 'SCP_PROJECT_TEAM',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryProjectTeamParams).then().then(response => {
        this.projectTeams = response.rows
        })
    },
    mounted () {
      this.onSearch()
    },
    methods: {
      // 列表-折换字段
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('mdm/mdmUomConversions/export', {
          ...this.queryParams
        }, `标准单位转换_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.id;
      },
      // 编辑-保存
      // handleSave (record) {
      //   if (!record.conversionRate || Number(record.conversionRate) <= 0) {
      //     this.$message.warning('折换不能为空且需大于0')
      //     return
      //   }
      //   updateUnit(record).then(response => {
      //     if (response.code === 200) {
      //       this.$message.success('保存成功')
      //       this.onSearch()
      //       this.isEdit = false;
      //     } else {
      //       this.$message.error(response.msg)
      //     }
      //   })
      // },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();

        // // this.linesVOList
        // apiItemProductAttributeList(this.queryParams).then(response => {
        //   if (response.code === 200) {
        //     this.tableDataList = response.data.linesVOList
        //     this.$refs.dataTable.myDataSource = this.tableDataList
        //   } else {
        //     this.$message.error(response.msg)
        //   }
        // })
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
            itemCode: undefined,
            orderType: undefined,
            projectTeam: undefined, // 项目组
            foldNumber: undefined, // 系列主型号
            softGoodLabel: undefined, // 软货标签
            isRetailFlag: undefined, // 是否一件代发
            isExpressFlag: undefined, // 是否快递
            scpSinvClassify: undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
